import { useFormContext } from 'react-hook-form';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectSitePricingProductsData } from '../../../../store/features/products';
import { PricingProductsDelegateTypeLayouts } from '../../../../types/enums';
import { PricingPackagesFormValues } from '../../../../store/features/packages/types';
import HorizontalTabs from './HorizontalTabs';
import VerticalTabs from './VerticalTabs';
import { MuiStack } from '../../../../../../modules/material';

export interface DelegateTypesTabsProps {
  onChangeTab: (delegateId: string) => void;
}

export default function DelegateTypesTabs(props: DelegateTypesTabsProps) {
  const { onChangeTab } = props;

  const { setValue } = useFormContext<PricingPackagesFormValues>();

  const {
    delegateTypes,
    delegateTypeLayout = PricingProductsDelegateTypeLayouts.HORIZONTAL,
  } = useRootSelector(selectSitePricingProductsData);

  if (!delegateTypes || delegateTypes.length === 0) {
    return null;
  }

  switch (delegateTypeLayout) {
    case PricingProductsDelegateTypeLayouts.HORIZONTAL: {
      return (
        <MuiStack>
          <HorizontalTabs
            onChange={(_, delegateId) => {
              setValue('delegateTypeId', delegateId);
              onChangeTab(delegateId);
            }}
          />
        </MuiStack>
      );
    }

    case PricingProductsDelegateTypeLayouts.VERTICAL: {
      return (
        <MuiStack>
          <VerticalTabs
            onChange={(_, delegateId) => {
              onChangeTab(delegateId);
            }}
          />
        </MuiStack>
      );
    }

    default: {
      return null;
    }
  }
}
